import { createMuiTheme } from '@material-ui/core/styles';

export const mainTheme = createMuiTheme({
  palette: {
    primary: { main: '#111111' },
    secondary: { main: '#f7a600' },
  },
});

export const newBuSTheme = createMuiTheme({
  palette: {
    primary: { main: '#111111' },
    secondary: { main: '#03274a' },
    text: {
      primary: '#2e2e2e',
    },
  },
  typography: {
    fontFamily: 'EB Garamond',
    fontSize: 16,
    button: {
      fontFamily: ['Montserrat', 'Helvetica', 'Arial', 'sans-serif'].join(','),
      fontWeight: 'bold',
      color: '#03274a',
    },
    h2: {
      fontSize: 36,
    },
    h4: {
      fontStyle: 'italic',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: '#fff',
        },
      },
    },
  },
});
